import { render, staticRenderFns } from "./exchange-rate-afir-form.pug?vue&type=template&id=49537aee&scoped=true&lang=pug&external"
import script from "./exchange-rate-afir-form.js?vue&type=script&lang=js&external"
export * from "./exchange-rate-afir-form.js?vue&type=script&lang=js&external"
import style0 from "./exchange-rate-afir-form.scss?vue&type=style&index=0&id=49537aee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49537aee",
  null
  
)

export default component.exports